'use client';
import { useEffect } from 'react';

export default function ServiceWorkerRegister() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      const registerWorker = async () => {
        const registration = await navigator.serviceWorker.getRegistration('/');
        const worker =
          registration?.installing ??
          registration?.waiting ??
          registration?.active;
        if (worker && new URL(worker.scriptURL).pathname === '/emarsys-sw.js') {
          return registration;
        }
        return navigator.serviceWorker.register('/sw.js');
      };
      const operation =
        'locks' in navigator
          ? navigator.locks.request('livat-emarsys', registerWorker)
          : registerWorker();
      void operation
        .then(() => console.log('Service Worker registered'))
        .catch((err) => console.error('SW registration failed:', err));
    }
  }, []);

  return null;
}

